import React from "react";
import { Avatar, List, Divider } from "antd";
import { useSelector } from "react-redux";

const Fact_Users = ({inputData}) => {
  const lang_choiced = useSelector((state) => state.lang_change);
  const data = inputData
  const check_name = (role) => {
    switch (role) {
      case "ceo":
        return lang_choiced.pages.add_fact.step4.sections[2].roles.ceo;
      case "expert":
        return  lang_choiced.pages.add_fact.step4.sections[2].roles.expert;
      case "contractor":
        return  lang_choiced.pages.add_fact.step4.sections[2].roles.contractor;
      default:
        return  lang_choiced.pages.add_fact.step4.sections[2].roles.member;
    }
  };
  return (
    <List
    size="small"
      itemLayout="horizontal"
      dataSource={data}
      renderItem={(item) => (
        <List.Item>
          <List.Item.Meta
            avatar={
              <Avatar />
            }
            title={<a>{item.name}</a>}
            description={
              <div>
                <span>{item.firstname} {" "} {item.lastname}</span>
                <Divider type="vertical"/>
                <span>{check_name(item.role)}</span>
              </div>
            }
          />
        </List.Item>
      )}
    />
  );
};

export default Fact_Users;
